import { Flex, Skeleton } from '@eqi-investimentos/react';

export const LoadingBrokerSection = () => (
  <Flex w="full" flexDir="column" gap="s">
    <Skeleton w="350px" h="22px" />
    <Flex flexDir="row" gap="s" w="full">
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton key={index} w="80px" h="22px" />
      ))}
    </Flex>
    <Flex flexDir="column">
      {Array.from({ length: 21 }).map((_, index) => (
        <Flex
          key={index}
          flexDir="row"
          gap="s"
          borderBottom="1px solid"
          borderColor="border.secondary"
          py="s"
        >
          <Skeleton w="30px" h="30px" />
          <Skeleton w="200px" h="30px" />
        </Flex>
      ))}
    </Flex>
  </Flex>
);
